import { ReactNode } from 'react';
import { Progress } from '@backstage/core-components';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core';

import { OndemandAdminWorkload } from '@internal/ondemand-admin-api-helper';

import { FormProvider } from 'react-hook-form';
import { Account } from '../types';
import { OndemandAdminInput } from './OndemandAdminInput';

interface OndemandAdminRequestIconProps {
  workloadData: Account | undefined;
  ondemandAdminData: OndemandAdminWorkload | undefined;
  requesterEmail: string;
  cardClass: string;
  cardContentClass: string;
  apiValidationPayload: any;
  isModalOpen: boolean;
  isLoading: boolean;
  handleClickOpen: any;
  handleClose: any;
  handleConfirm: any;
  progress?: ReactNode;
}

export function OndemandAdminRequestIcon(props: OndemandAdminRequestIconProps) {
  return (
    <CardActions>
      <Dialog
        fullWidth
        maxWidth="md"
        open={props.isModalOpen}
        onClose={props.handleClose}
      >
        <form onSubmit={props.handleConfirm} autoComplete="off">
          <DialogTitle>Provide Justification</DialogTitle>
          <DialogContent>
            <Card className={props.cardClass}>
              <Divider />
              <CardContent className={props.cardContentClass}>
                <FormProvider {...props.apiValidationPayload.form}>
                  <OndemandAdminInput
                    {...props.apiValidationPayload}
                    nonGovernanceValidation={false}
                    disabled={props.isLoading}
                  />
                  {/* <StructuredMetadataTable
                    metadata={{
                      'Budget Amount': (
                        <>
                          <OndemandAdminExampleInput
                            {...props.apiValidationPayload}
                            existingBudgetAmount={String(
                              props.features?.budget?.amount,
                            )}
                            nonGovernanceValidation={false}
                            disabled={props.isLoading}
                          />
                        </>
                      ),
                    }}
                  /> */}
                  <Typography>
                    Provide justification for gaining elevated access. An email
                    will be sent when access has been provisioned
                  </Typography>
                </FormProvider>
                {props.progress}
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions>
            {props.isLoading ? (
              <div>
                loading... <Progress />
              </div>
            ) : (
              <></>
            )}
            <Button
              onClick={props.handleClose}
              color="primary"
              disabled={props.isLoading}
            >
              Cancel
            </Button>
            <Button
              disabled={
                props.isLoading ||
                Object.keys(props.apiValidationPayload.form.formState.errors)
                  .length > 0
              }
              type="submit"
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </CardActions>
  );
}
